import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { useApp } from "../../contexts/AppContext";
import styles from "./RouteQRModal.module.css";

interface RouteQRModalProps {
  isOpen: boolean;
  onClose: () => void;
  terminalName: string | null;
  shopId: string | number | undefined;
}

const RouteQRModal: React.FC<RouteQRModalProps> = ({
  isOpen,
  onClose,
  terminalName,
  shopId,
}) => {
  const { state } = useApp();

  if (!isOpen) return null;

  // Формируем URL для QR-кода
  // Используем базовый URL фронтенда (window.location.origin) для роута /mobility
  const frontendUrl = window.location.origin;
  const qrUrl = terminalName && shopId
    ? `${frontendUrl}/mobility?terminalName=${encodeURIComponent(terminalName)}&shopId=${encodeURIComponent(String(shopId))}`
    : "";

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div className={styles.content}>
          <h2 className={styles.title}>
            {state.language === "en" ? "Route with you" : "Маршрут с собой"}
          </h2>
          {qrUrl ? (
            <div className={styles.qrContainer}>
              <QRCodeSVG value={qrUrl} size={300} level="H" />
            </div>
          ) : (
            <div className={styles.error}>
              {state.language === "en"
                ? "Unable to generate QR code"
                : "Не удалось сгенерировать QR-код"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RouteQRModal;

